
import { defineComponent, PropType } from 'vue'
import { iHierarchyTarget } from '../../../HierarchyManagement'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import hierarchyManagementHierarchiesTreeDescriptor from './HierarchyManagementHierarchiesTreeDescriptor.json'

export default defineComponent({
    name: 'hierarchy-management-node-detail-dialog',
    components: { Column, DataTable, Dialog },
    props: { visible: { type: Boolean }, hierarchiesTargets: { type: Array as PropType<iHierarchyTarget[]> } },
    emits: ['save', 'close'],
    data() {
        return {
            hierarchyManagementHierarchiesTreeDescriptor,
            targets: [] as iHierarchyTarget[],
            selectedTargets: [] as iHierarchyTarget[]
        }
    },
    watch: {
        hierarchiesTargets() {
            if (this.visible) this.loadTargets()
        }
    },
    created() {
        this.loadTargets()
    },
    methods: {
        loadTargets() {
            this.targets = this.hierarchiesTargets as iHierarchyTarget[]
        },
        getLabel(target: iHierarchyTarget) {
            return this.$t('managers.hierarchyManagement.hierarchy').toUpperCase() + ': ' + target.HIER_CD_T + ' - ' + target.HIER_NM_T + ' - ' + this.$t('managers.hierarchyManagement.levelNode') + ': ' + target.NODE_LEV_T
        },
        close() {
            this.selectedTargets = []
            this.$emit('close')
        },
        save() {
            this.$emit('save', [...this.selectedTargets])
            this.selectedTargets = []
        }
    }
})
